/**
 * Lift wsr-api envelope `code` from `ApiError.details` (WSRADM-0026).
 *
 * Shared by ConfigurationPage and DimensionStructureEditor. Compare as a plain
 * string — do not narrow to DimensionErrorCode.
 */
import { ApiError } from '@/api/errors';

export function detailsCode(err: unknown): string | undefined {
  if (err instanceof ApiError && typeof err.details?.['code'] === 'string') {
    return err.details['code'];
  }
  return undefined;
}
